export const mockLawyers = [
    {
        id: 1,
        name: "Thabo Mbeki, Adv.",
        firm: "Johannesburg Legal Associates",
        specialties: ["corporate", "commercialLaw", "internationalTrade"],
        languages: ["English", "Xhosa", "Zulu"],
        location: {
            city: "Johannesburg",
            province: "Gauteng",
            address: "123 Sandton Drive, Sandton",
            coordinates: { lat: -26.107567, lng: 28.056702 }
        },
        bio: "Thabo Mbeki is a senior advocate specializing in corporate law and international trade regulations. With over 15 years of experience, he has represented major South African corporations in cross-border transactions and international arbitration cases. His expertise in navigating complex commercial landscapes has made him a sought-after legal advisor for businesses expanding throughout Africa.",
        admission: {
            court: "High Court of South Africa",
            year: 2008
        },
        contact: {
            email: "tmbeki@jla.co.za",
            phone: "+27 11 234 5678",
            assistant: {
                name: "Precious Ndlovu",
                email: "pndlovu@jla.co.za",
                phone: "+27 11 234 5679"
            },
            hours: {
                weekday: "8:30 AM - 5:00 PM",
                saturday: "9:00 AM - 12:00 PM"
            }
        }
    },
    {
        id: 2,
        name: "Nomzamo Radebe",
        firm: "Cape Town Legal Partners",
        specialties: ["propertyLaw", "estatePlanning", "realEstate"],
        languages: ["English", "Afrikaans", "Xhosa"],
        location: {
            city: "Cape Town",
            province: "Western Cape",
            address: "45 Long Street, City Centre",
            coordinates: { lat: -33.924870, lng: 18.424055 }
        },
        bio: "Nomzamo Radebe is a property law specialist with extensive experience in real estate transactions and estate planning. She advises both individual and corporate clients on property acquisitions, disposals, and development projects throughout the Western Cape. Her knowledge of South African property law has been instrumental in navigating complex legal frameworks for various high-value property transactions.",
        admission: {
            court: "High Court of South Africa",
            year: 2010
        },
        contact: {
            email: "nradebe@ctlp.co.za",
            phone: "+27 21 555 7890",
            assistant: {
                name: "Johan van der Merwe",
                email: "jvandermerwe@ctlp.co.za",
                phone: "+27 21 555 7891"
            },
            hours: {
                weekday: "8:00 AM - 5:30 PM",
                saturday: "By appointment only"
            }
        }
    },
    {
        id: 3,
        name: "Sipho Mthembu",
        firm: "Durban Litigation Specialists",
        specialties: ["litigation", "laborLaw", "disputeResolution"],
        languages: ["English", "Zulu", "Sotho"],
        location: {
            city: "Durban",
            province: "KwaZulu-Natal",
            address: "78 Umhlanga Rocks Drive, Umhlanga",
            coordinates: { lat: -29.726990, lng: 31.085230 }
        },
        bio: "Sipho Mthembu is a litigation attorney with particular expertise in labor law and dispute resolution. He has successfully represented clients in the Labor Court, CCMA, and various bargaining councils. His strategic approach to labor disputes has resulted in favorable settlements for numerous employers and employees across KwaZulu-Natal.",
        admission: {
            court: "High Court of South Africa",
            year: 2012
        },
        contact: {
            email: "smthembu@dls.co.za",
            phone: "+27 31 789 2345",
            assistant: {
                name: "Thandi Ngcobo",
                email: "tngcobo@dls.co.za",
                phone: "+27 31 789 2346"
            },
            hours: {
                weekday: "8:30 AM - 4:30 PM",
                saturday: "Closed"
            }
        }
    },
    {
        id: 4,
        name: "Lerato Molefe",
        firm: "Pretoria Family Law Practitioners",
        specialties: ["familyLaw", "divorce", "childCustody"],
        languages: ["English", "Tswana", "Afrikaans"],
        location: {
            city: "Pretoria",
            province: "Gauteng",
            address: "15 Pretorius Street, Hatfield",
            coordinates: { lat: -25.749738, lng: 28.237033 }
        },
        bio: "Lerato Molefe is a dedicated family law attorney specializing in divorce proceedings and child custody matters. With a compassionate approach to sensitive family issues, she has guided numerous clients through complex family law challenges. Her expertise in South African family law and her ability to negotiate favorable settlements have earned her a strong reputation in the field.",
        admission: {
            court: "High Court of South Africa",
            year: 2015
        },
        contact: {
            email: "lmolefe@pflp.co.za",
            phone: "+27 12 345 6789",
            assistant: {
                name: "Daniel Botha",
                email: "dbotha@pflp.co.za",
                phone: "+27 12 345 6780"
            },
            hours: {
                weekday: "9:00 AM - 5:00 PM",
                saturday: "9:00 AM - 1:00 PM"
            }
        }
    },
    {
        id: 5,
        name: "Ahmed Patel",
        firm: "Port Elizabeth Legal Consortium",
        specialties: ["criminalLaw", "humanRights", "constitutionalLaw"],
        languages: ["English", "Afrikaans", "Xhosa"],
        location: {
            city: "Port Elizabeth",
            province: "Eastern Cape",
            address: "33 Govan Mbeki Avenue, Central",
            coordinates: { lat: -33.964806, lng: 25.617884 }
        },
        bio: "Ahmed Patel is a criminal defense attorney with a strong focus on human rights and constitutional law. He has represented clients in high-profile criminal cases throughout the Eastern Cape. His dedication to justice and human rights has made him an advocate for legal reform in South Africa, particularly regarding access to justice for marginalized communities.",
        admission: {
            court: "High Court of South Africa",
            year: 2009
        },
        contact: {
            email: "apatel@pelc.co.za",
            phone: "+27 41 567 8901",
            assistant: {
                name: "Anele Msimang",
                email: "amsimang@pelc.co.za",
                phone: "+27 41 567 8902"
            },
            hours: {
                weekday: "8:00 AM - 4:00 PM",
                saturday: "By appointment only"
            }
        }
    },
    {
        id: 6,
        name: "Zainab Moosa",
        firm: "Johannesburg IP Specialists",
        specialties: ["intellectualProperty", "technologyLaw", "patents"],
        languages: ["English", "Gujarati", "Afrikaans"],
        location: {
            city: "Johannesburg",
            province: "Gauteng",
            address: "87 Rivonia Road, Sandton",
            coordinates: { lat: -26.107600, lng: 28.052400 }
        },
        bio: "Zainab Moosa is an expert in intellectual property law, with particular focus on patent protection and technology law. She has advised both local and international tech companies on protecting their intellectual property rights in South Africa and across the continent. Her understanding of the intersection between technology and law has made her a valuable advisor for innovative businesses.",
        admission: {
            court: "High Court of South Africa",
            year: 2011
        },
        contact: {
            email: "zmoosa@jips.co.za",
            phone: "+27 11 890 1234",
            assistant: {
                name: "Trevor Naidoo",
                email: "tnaidoo@jips.co.za",
                phone: "+27 11 890 1235"
            },
            hours: {
                weekday: "8:30 AM - 5:30 PM",
                saturday: "Closed"
            }
        }
    },
    {
        id: 7,
        name: "Willem van Niekerk",
        firm: "Bloemfontein Advocates Chamber",
        specialties: ["corporate", "taxLaw", "commercialLaw"],
        languages: ["English", "Afrikaans", "Sesotho"],
        location: {
            city: "Bloemfontein",
            province: "Free State",
            address: "12 President Brand Street, Central",
            coordinates: { lat: -29.119500, lng: 26.214600 }
        },
        bio: "Willem van Niekerk is a senior advocate with extensive experience in tax law and corporate structuring. Based in Bloemfontein, he has advised businesses across the Free State on tax compliance, corporate governance, and commercial transactions. His strategic approach to business law has helped numerous companies optimize their legal and tax positions in accordance with South African regulations.",
        admission: {
            court: "Supreme Court of Appeal",
            year: 2007
        },
        contact: {
            email: "wvanniekerk@bac.co.za",
            phone: "+27 51 432 5678",
            assistant: {
                name: "Suzanne Pretorius",
                email: "spretorius@bac.co.za",
                phone: "+27 51 432 5679"
            },
            hours: {
                weekday: "8:00 AM - 5:00 PM",
                saturday: "By appointment only"
            }
        }
    },
    {
        id: 9,
        name: "Themba Ngcobo",
        firm: "Durban Corporate Law Group",
        specialties: ["corporate", "mergersAndAcquisitions", "businessLaw"],
        languages: ["English", "Zulu", "Sotho"],
        location: {
            city: "Durban",
            province: "KwaZulu-Natal",
            address: "56 North Beach Road, Durban North",
            coordinates: { lat: -29.7415, lng: 31.0477 }
        },
        bio: "Themba Ngcobo is a corporate law expert with a strong focus on mergers, acquisitions, and corporate governance. His experience spans industries such as finance, real estate, and telecommunications. His clients range from startups to multinational corporations, and he is known for his strategic advice and efficient deal-making.",
        admission: {
            court: "High Court of South Africa",
            year: 2010
        },
        contact: {
            email: "tngcobo@dclg.co.za",
            phone: "+27 31 890 1234",
            assistant: {
                name: "Sipho Khumalo",
                email: "skhumalo@dclg.co.za",
                phone: "+27 31 890 1235"
            },
            hours: {
                weekday: "9:00 AM - 6:00 PM",
                saturday: "By appointment only"
            }
        }
    },
    {
        id: 10,
        name: "Lindiwe Mhlongo",
        firm: "Cape Town Immigration Law Firm",
        specialties: ["immigrationLaw", "asylum", "visaApplications"],
        languages: ["English", "Xhosa", "Afrikaans"],
        location: {
            city: "Cape Town",
            province: "Western Cape",
            address: "102 Waterfront Road, Green Point",
            coordinates: { lat: -33.9208, lng: 18.4232 }
        },
        bio: "Lindiwe Mhlongo specializes in immigration law, with a focus on visa applications, asylum cases, and permanent residency. She has successfully represented clients in numerous immigration hearings and provides expert guidance on South Africa's complex immigration policies. Her dedication to helping clients navigate the immigration process has earned her a strong reputation in the legal community.",
        admission: {
            court: "High Court of South Africa",
            year: 2014
        },
        contact: {
            email: "lmhlongo@ctilf.co.za",
            phone: "+27 21 321 6789",
            assistant: {
                name: "Ethan Louw",
                email: "elouw@ctilf.co.za",
                phone: "+27 21 321 6790"
            },
            hours: {
                weekday: "8:30 AM - 5:00 PM",
                saturday: "Closed"
            }
        }
    },
    {
        id: 11,
        name: "Jaco van der Merwe",
        firm: "Pretoria Environmental Law Attorneys",
        specialties: ["environmentalLaw", "sustainability", "landUse"],
        languages: ["English", "Afrikaans", "Zulu"],
        location: {
            city: "Pretoria",
            province: "Gauteng",
            address: "34 Rivier Street, Pretoria West",
            coordinates: { lat: -25.7479, lng: 28.2290 }
        },
        bio: "Jaco van der Merwe is an environmental law expert who provides legal counsel to businesses and government entities on environmental compliance, sustainability, and land use regulations. With a deep understanding of South African environmental policies, Jaco has successfully represented clients in cases involving environmental conservation and resource management.",
        admission: {
            court: "High Court of South Africa",
            year: 2012
        },
        contact: {
            email: "jvandermerwe@pla.co.za",
            phone: "+27 12 456 7890",
            assistant: {
                name: "Michaela Botha",
                email: "mbotha@pla.co.za",
                phone: "+27 12 456 7891"
            },
            hours: {
                weekday: "8:00 AM - 4:30 PM",
                saturday: "By appointment only"
            }
        }
    },
    {
        id: 12,
        name: "Musa Dlamini",
        firm: "East London Personal Injury Attorneys",
        specialties: ["personalInjury", "accidentClaims", "medicalNegligence"],
        languages: ["English", "Xhosa", "Sotho"],
        location: {
            city: "East London",
            province: "Eastern Cape",
            address: "21 Oxford Street, East London Central",
            coordinates: { lat: -32.9793, lng: 27.9017 }
        },
        bio: "Musa Dlamini is a personal injury attorney specializing in accident claims and medical negligence. With a strong track record in high-value injury claims, he has fought for justice for victims of road accidents and workplace injuries. Musa is known for his empathy, thorough legal knowledge, and relentless pursuit of compensation for his clients.",
        admission: {
            court: "High Court of South Africa",
            year: 2008
        },
        contact: {
            email: "mdlamini@elpia.co.za",
            phone: "+27 43 123 4567",
            assistant: {
                name: "Dineo Khubeka",
                email: "dkhubeka@elpia.co.za",
                phone: "+27 43 123 4568"
            },
            hours: {
                weekday: "8:30 AM - 5:00 PM",
                saturday: "Closed"
            }
        }
    },
    {
        id: 13,
        name: "Gugu Ndlovu",
        firm: "Johannesburg Labour Law Advisors",
        specialties: ["laborLaw", "unfairDismissal", "workplaceDisputes"],
        languages: ["English", "Zulu", "Xhosa"],
        location: {
            city: "Johannesburg",
            province: "Gauteng",
            address: "21 Marshall Street, Johannesburg Central",
            coordinates: { lat: -26.2025, lng: 28.0425 }
        },
        bio: "Gugu Ndlovu is a labor law attorney with extensive experience in handling unfair dismissal cases and workplace disputes. She represents both employees and employers in labor matters, providing strategic advice and representation in arbitration, tribunal hearings, and litigation. Gugu's expertise has helped resolve complex labor disputes across various industries.",
        admission: {
            court: "Labour Court of South Africa",
            year: 2011
        },
        contact: {
            email: "gndlovu@jllaw.co.za",
            phone: "+27 11 234 7890",
            assistant: {
                name: "Khanya Zulu",
                email: "kzulu@jllaw.co.za",
                phone: "+27 11 234 7891"
            },
            hours: {
                weekday: "9:00 AM - 5:00 PM",
                saturday: "Closed"
            }
        }
    },
    {
        id: 14,
        name: "Sibusiso Mthembu",
        firm: "Port Elizabeth Civil Litigation Experts",
        specialties: ["civilLitigation", "propertyDisputes", "contractLaw"],
        languages: ["English", "Xhosa", "Afrikaans"],
        location: {
            city: "Port Elizabeth",
            province: "Eastern Cape",
            address: "89 Cape Road, Newton Park",
            coordinates: { lat: -33.9715, lng: 25.5939 }
        },
        bio: "Sibusiso Mthembu is a civil litigation attorney focusing on property disputes, breach of contract, and general civil litigation. He has successfully represented clients in both the Magistrate’s and High Courts, ensuring fair resolution of contractual and property-related issues. His attention to detail and commitment to legal fairness have made him a trusted name in civil litigation.",
        admission: {
            court: "High Court of South Africa",
            year: 2014
        },
        contact: {
            email: "smthembu@pelc.co.za",
            phone: "+27 41 234 5678",
            assistant: {
                name: "Julius Mokoena",
                email: "jmokoena@pelc.co.za",
                phone: "+27 41 234 5679"
            },
            hours: {
                weekday: "8:30 AM - 5:00 PM",
                saturday: "By appointment only"
            }
        }
    },
    {
        id: 8,
        name: "Nkosazana Dlamini-Zuma",
        firm: "Pretoria Constitutional Law Associates",
        specialties: ["constitutionalLaw", "publicLaw", "administrativeLaw"],
        languages: ["English", "Zulu", "Tswana"],
        location: {
            city: "Pretoria",
            province: "Gauteng",
            address: "100 Church Street, Pretoria Central",
            coordinates: { lat: -25.746220, lng: 28.189232 }
        },
        bio: "Nkosazana Dlamini-Zuma specializes in constitutional, public, and administrative law. She has represented public entities and individuals in numerous landmark cases before the Constitutional Court of South Africa. Her deep understanding of South African constitutional principles and public administration has made her an authority in the field of constitutional law.",
        admission: {
            court: "Constitutional Court of South Africa",
            year: 2013
        },
        contact: {
            email: "ndlamini@plalaw.co.za",
            phone: "+27 12 345 6789",
            assistant: {
                name: "Bongi Masilela",
                email: "bmasilela@plalaw.co.za",
                phone: "+27 12 345 6790"
            },
            hours: {
                weekday: "9:00 AM - 5:00 PM",
                saturday: "Closed"
            }
        }
    },
];

export default mockLawyers;